import React from 'react';
import { PatternFormat, PatternFormatProps } from 'react-number-format';

interface CustomProps {
	onChange: (event: { target: { name: string; value: string } }) => void;
	name: string;
}

const SortCodeFormat = React.forwardRef<PatternFormatProps, CustomProps>((props, ref) => {
	const { onChange, ...other } = props;

	return (
		<PatternFormat
			{...other}
			inputMode='numeric'
			pattern='[0-9]{2}-[0-9]{2}-[0-9]{2}'
			getInputRef={ref}
			onValueChange={(values) => {
				onChange({
					target: {
						name: props.name,
						value: values.value,
					},
				});
			}}
			format='##-##-##'
			mask='_'
		/>
	);
});

SortCodeFormat.displayName = 'SortCodeFormat';

export default SortCodeFormat;
